function parsePromotionData(data: any) {
  // Nếu data là object (dataItem), lấy trực tiếp các trường
  if (typeof data === "object" && data !== null) {
    const buildNoVga = data.giaBuildPcKoVga ?? undefined;
    const buildWithVga = data.unitSellingPrice ?? undefined;
    const retailPrice = data.price1 ?? undefined;
    const hasRetail = data.coBanLe !== "N";
    return { buildNoVga, buildWithVga, retailPrice, hasRetail };
  }
  // Nếu data là string, giữ nguyên logic cũ
  const buildNoVgaMatch = data.match(/GIÁ BUILD PC KO VGA=(\d+)/i);
  const buildNoVga = buildNoVgaMatch ? Number(buildNoVgaMatch[1]) : undefined;

  const buildWithVgaMatch = data.match(/GIÁ BUILD PC KÈM VGA=(\d+)/i);
  const buildWithVga = buildWithVgaMatch
    ? Number(buildWithVgaMatch[1])
    : undefined;

  const retailMatch = data.match(/GIÁ BÁN LẺ=(\d+)/i);
  const retailPrice = retailMatch ? Number(retailMatch[1]) : undefined;

  const hasRetailMatch = data?.match(/CO_BAN_LE=([YN])/i);
  const hasRetail = !hasRetailMatch || hasRetailMatch[1] === "Y";

  return { buildNoVga, buildWithVga, retailPrice, hasRetail };
}

export default function CPUPromotionWeb({ data }: { data: any }) {
  const { buildNoVga, buildWithVga, retailPrice, hasRetail } =
    parsePromotionData(data);

  return (
    <div
      style={{
        overflow: "hidden",
        borderRadius: "0.375rem", // rounded-md
        border: "1px solid #e5e7eb", // border-gray-200
        backgroundColor: "#ffffff", // bg-white
      }}
    >
      {/* Header Section */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #f3f4f6", // border-gray-100
          backgroundColor: "#f9fafb", // bg-gray-50
          padding: "8px 12px", // px-3 py-2
        }}
      >
        <div
          style={{
            fontSize: "16px",
            fontWeight: "bold",
            textTransform: "uppercase",
            letterSpacing: "0.025em", // tracking-wide
            color: "#E72429",
          }}
        >
          Ưu đãi - Giảm sốc CPU tại HACOM
        </div>
        <svg
          aria-hidden="true"
          style={{
            height: "20px", // h-5
            width: "20px", // w-5
            color: "#E72429",
          }}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            clipRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.06z"
            fillRule="evenodd"
          />
        </svg>
      </div>

      {/* Body/Content Section */}
      <div
        style={{
          padding: "16px 12px", // px-3 py-4
          letterSpacing: "0.025em", // tracking-wide
          color: "#1f2937", // text-gray-800
        }}
      >
        <ul
          style={{
            listStyleType: "disc",
            paddingLeft: "24px", // pl-6
            fontSize: "14.5px", // text-[14.5px]
            lineHeight: "24px", // leading-6
          }}
        >
          {buildWithVga !== undefined && (
            <li style={{ marginBottom: "8px" }}>
              {" "}
              {/* space-y-2 alternative */}
              Giá Build PC có VGA:{" "}
              <span
                style={{
                  fontWeight: 600, // font-semibold
                  letterSpacing: "0.05em", // tracking-wider
                  color: "#dc2626", // text-red-600
                }}
              >
                {buildWithVga.toLocaleString("vi-VN")}đ
              </span>{" "}
              khi mua kèm Mainboard, SSD, RAM, Case, Nguồn,{" "}
              <span
                style={{
                  fontWeight: "bold",
                  letterSpacing: "0.05em",
                  color: "#000000",
                }}
              >
                VGA từ RX6500XT, RTX3050
              </span>{" "}
              trở lên.
            </li>
          )}

          {buildNoVga !== undefined && (
            <li style={{ marginBottom: "8px" }}>
              Giá Build PC:{" "}
              <span
                style={{
                  fontWeight: 600,
                  letterSpacing: "0.05em",
                  color: "#dc2626",
                }}
              >
                {buildNoVga.toLocaleString("vi-VN")}đ
              </span>{" "}
              khi mua kèm Mainboard, SSD, RAM, Case, Nguồn
            </li>
          )}

          {hasRetail && retailPrice !== undefined && (
            <li style={{ marginBottom: "8px" }}>
              Giá bán lẻ CPU:{" "}
              <span
                style={{
                  fontWeight: 600,
                  letterSpacing: "0.05em",
                  color: "#dc2626",
                }}
              >
                {retailPrice.toLocaleString("vi-VN")}đ
              </span>
            </li>
          )}

          <li style={{ marginBottom: "8px" }}>
            <span
              style={{
                fontWeight: "bold",
                letterSpacing: "0.05em",
                color: "#000000",
              }}
            >
              Giảm giá lên tới{" "}
              <span
                style={{
                  fontWeight: 600,
                  letterSpacing: "0.05em",
                  color: "#dc2626",
                }}
              >
                30.000.000đ
              </span>{" "}
              khi khách hàng Build trọn bộ PC tại HACOM
            </span>{" "}
            <a
              style={{
                color: "#2563eb", // text-blue-600
                textDecoration: "underline",
              }}
              href="/build-pc"
              rel="noopener noreferrer"
              target="_blank"
            >
              (Xem chi tiết)
            </a>{" "}
            <span aria-label="hand" role="img">
              👈
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
}
